/** Just a type-enforced lowercase string */
export type LowerString = Lowercase<string>;

export type EthAddress = `0x${LowerString}`;
export type WalletAddress = EthAddress;
export type ContractAddress = EthAddress;

/**
* Type guard for ethereum address strings.
* Converts the string to lowercase then validates the length and prefix.
* Throws if the provided string is the wrong length or does not start with 0x.
*/
export function ethAddress(address:string): EthAddress & LowerString {
    const laddress = address.toLowerCase();
    if (!laddress.startsWith('0x') || laddress.length !== 42) {
      throw new Error(`Invalid contract address: ${address}`);
    }
    return laddress as EthAddress;
}

/** Just like ethAddress but returns a WalletAddress type (identical format, more specific use-case) */
export function walletAddress(address: string): WalletAddress {
    return ethAddress(address) as WalletAddress;
}
/** Just like ethAddress but returns a ContractAddress type (identical format, more specific use-case) */
export function contractAddress(address: string): ContractAddress {
    return ethAddress(address) as ContractAddress;
}
